import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Achievement_update($id: ID!, $name: String) {
    Achievement_update(id: $id, name: $name) {
      value
    }
  }
`;

const achievementUpdate = async ({ id, name }) => {
  graphql(mutation, { id, name })
    // eslint-disable-next-line camelcase
    .then(({ Achievement_update }) => Achievement_update)
    .catch(e => e);
};

export default achievementUpdate;
